import { render, staticRenderFns } from "./ChatHero.vue?vue&type=template&id=62e82364&"
import script from "./ChatHero.vue?vue&type=script&lang=js&"
export * from "./ChatHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports